import VueRouter from 'vue-router'
// 1. 定义（路由）组件。=> import
// import Login from '../business/login.vue';
// import Home from '@/business/app-home.vue';

// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// export const routeHome = {path:'/home', component: Home, meta:{r:{k:'home', v:'<i class="fa fa-home"></i> 我的主页'}}};


// all Route
import { webRoute } from './web';

let routes = [];
Object.keys(webRoute).forEach(k => {
  let _route = webRoute[k];
  if (Array.isArray(_route)) {
    routes = routes.concat(_route);
  } else {
    routes.push(_route);
  }
});

// console.log(routes)

// scrollBehavior: -- 仅在HTML5 history 模式下可用。
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior_ = (to, from, savedPosition) => {
  // console.log('to'+ to)
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    // console.log('to.hash'+ to.hash)
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    } else {
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  //base: '', // 基路径，仅html5 history 模式下可用。
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      from.meta.y = document.body.scrollTop;
      // console.log(to.meta.y)
      return { x: 0, y: to.meta.y || 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  to.meta.loading = true;
  from.meta.loading = true;
  next();
});
router.afterEach((to, from) => {
  to.meta.loading = false;
  from.meta.loading = false;
});

export default router
